import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Resource/components/Card';
import FormContainer from './components/FormContainer';

class Voucher extends React.Component {
  render() {
    const { voucher, hashid, lang } = this.props;

    return (
      <Card title={lang.topic}>
        <FormContainer
          voucher={voucher}
          lang={lang}
          hashid={hashid}
        />

      </Card>

    );
  }
}
// Todo: PropTypes


export default Voucher;

Voucher.propTypes = {
  voucher: PropTypes.func.isRequired,
  hashid: PropTypes.string.isRequired,
  lang: PropTypes.object.isRequired,


};



// WEBPACK FOOTER //
// ./src/components/Voucher/index.jsx